export const MANUAL_ID_VERIFICATION_STATUS_PENDING = 'Pending';
export const MANUAL_ID_VERIFICATION_STATUS_APPROVED = 'Approved';
export const MANUAL_ID_VERIFICATION_STATUS_REJECTED = 'Rejected';
export const MANUAL_ID_VERIFICATION_STATUS_RETRY = 'Retry';
